export const AUTH = '/auth'
export const AUTH_SMS = AUTH + '/sms'
export const AUTH_EMAIL = AUTH + '/email'

export const CART = '/cart'
export const CART_API_ADDITIONAL = CART + '/additional'
export const API_CART_DELAY = CART + '/delay'
export const API_CART_SERVICE = CART + '/service'
export const API_CART_DELETE = CART + '/delete'
export const API_CART_SHARE = CART + '/share'

export const FAVOURITES = '/favourites'

export const COMPARE = '/compare'
export const COMPARE_EXTEND_API = COMPARE + '/extend'

export const SEARCH_API = '/search'

export const CATALOG_API = '/catalog'
export const CATALOG_MENU_API = CATALOG_API + '/menu'

export const PRODUCTS_API = '/products'
export const PRODUCTS_ADDITIONAL_API = PRODUCTS_API + '/additional'
export const getProductReviewsApi = (id: string | number) =>
  `${PRODUCTS_API}/${id}/reviews`
export const getProductReviewVoteApi = (id: string | number) =>
  `${PRODUCTS_API}/${id}/reviews/vote`
export const getProductSpecificationReportApi = (id: string | number) =>
  `${PRODUCTS_API}/${id}/specification-report`

export const CONFIG_API = '/config'
export const CONFIG_FCM_API = CONFIG_API + '/fcm'
export const CONFIG_TOKEN_API = CONFIG_API + '/token'
export const CONFIG_CLIENT_LOG_API = CONFIG_API + '/client-log'
export const CONFIG_CSS_API = CONFIG_API + '/css'
export const CONFIG_NATIVE_API = CONFIG_API + '/native'

export const CONFIG_LAYOUT_API = CONFIG_API + '/layout'
export const CONFIG_LAYOUT_HEADER_API = CONFIG_LAYOUT_API + '/header'
export const CONFIG_LAYOUT_HEADER_HEADER_MENU_API =
  CONFIG_LAYOUT_HEADER_API + '/headerMenu'
export const CONFIG_LAYOUT_HEADER_INFO_MENU_API =
  CONFIG_LAYOUT_HEADER_API + '/infoMenu'
export const CONFIG_LAYOUT_FOOTER_API = CONFIG_LAYOUT_API + '/footer'
export const CONFIG_LAYOUT_FOOTER_SITEMAP_API =
  CONFIG_LAYOUT_FOOTER_API + '/sitemap'
export const CONFIG_UTM = CONFIG_API + '/utm'
export const CONFIG_UTM_SET = CONFIG_UTM + '/set'
export const LOCATION_API = '/location'
export const LOCATION_CURRENT_API = LOCATION_API + '/current'
export const LOCATION_GPS_API = LOCATION_API + '/gps'

export const CONTENT_API = '/content'

export const REVIEWS_API = '/reviews'
export const REVIEWS_PHOTO_API = REVIEWS_API + '/photo'

export const ORDER_API = '/order'
export const ORDER_MAKE_API = ORDER_API + '/make'
export const ORDER_CREDIT_API = ORDER_API + '/credit'
export const ORDER_PAY_API = ORDER_API + '/pay'

export const PERSONAL_API = '/personal'
export const PERSONAL_PROFILE_API = PERSONAL_API + '/profile'
export const PERSONAL_PROFILE_REMOVE_API = PERSONAL_PROFILE_API + '/remove'
export const PERSONAL_ORDERS_API = PERSONAL_API + '/orders'
export const PERSONAL_BONUSES_API = PERSONAL_API + '/bonuses'
export const PERSONAL_REVIEWS_API = PERSONAL_API + '/reviews'
export const getPersonalReviewApi = (id: string | number) =>
  `${PERSONAL_REVIEWS_API}/${id}`

export const ADS_API = '/ads'
export const getAdApi = (id: string | number) => `${ADS_API}/${id}`

export const PERSONAL_ADS_API = PERSONAL_API + '/ads'
export const PERSONAL_ADS_RULES_API = PERSONAL_ADS_API + '/rules'
export const getPersonalAdApi = (id: string | number) =>
  `${PERSONAL_ADS_API}/${id}`
export const getPersonalAdStatusApi = (id: string | number) =>
  `${PERSONAL_ADS_API}/${id}/status`

export const HELP_API = '/help'
export const INFO_API = '/info'
export const WARRANTY_API = HELP_API + '/warranty'

export const COMPANY_API = '/company'
export const ABOUT_API = COMPANY_API + '/about'
export const REQUISITES_API = COMPANY_API + '/requisites'
export const CONTACTS_API = COMPANY_API + '/contacts'
export const CONTACTS_FEEDBACK_API = CONTACTS_API + '/feedback/'

export const DOCS_API = '/docs'
export const SALE_RULES_API = DOCS_API + '/sale-rules'
export const PRIVACY_POLICY_API = DOCS_API + '/privacy-policy'

export const NEWS_API = '/news'
export const ACTIONS_API = '/actions'
export const BRANDS_API = '/brands'
export const STORES_API = '/stores'
export const VIDEO_API = '/video'
export const GALLERY_API = '/gallery'

export const COLLECTIONS_API = '/collections'

export const INDEX_API = '/index'
export const INDEX_API_STRUCTURE = INDEX_API + '/structure'
export const API_INDEX_PARTIAL = INDEX_API + '/partial'
export const API_INDEX_PARTIAL_LCP = API_INDEX_PARTIAL + '/lcp'
export const API_INDEX_PARTIAL_META = API_INDEX_PARTIAL + '/meta'
export const API_INDEX_PARTIAL_SLIDER = API_INDEX_PARTIAL + '/slider'
export const API_INDEX_PARTIAL_PRODUCT_DAY = API_INDEX_PARTIAL + '/productDay'
export const API_INDEX_PARTIAL_BANNERS = API_INDEX_PARTIAL + '/banners'
export const API_INDEX_PARTIAL_PRODUCTS = API_INDEX_PARTIAL + '/products'
export const API_INDEX_PARTIAL_CATEGORIES = API_INDEX_PARTIAL + '/categories'
export const API_INDEX_PARTIAL_COLLECTIONS = API_INDEX_PARTIAL + '/collections'
export const API_INDEX_PARTIAL_ACTIONS = API_INDEX_PARTIAL + '/actions'
export const API_INDEX_PARTIAL_BRANDS = API_INDEX_PARTIAL + '/brands'
export const API_INDEX_PARTIAL_ARTICLES = API_INDEX_PARTIAL + '/articles'
export const API_INDEX_PARTIAL_TEXT = API_INDEX_PARTIAL + '/text'
export const API_INDEX_PARTIAL_VIDEOS = API_INDEX_PARTIAL + '/video'
export const API_INDEX_PARTIAL_STORIES = API_INDEX_PARTIAL + '/stories'
export const API_INDEX_STARTUP_STORY = INDEX_API + '/startup-story'
export const API_REPORT = '/report'
export const API_REPORT_ARRIVAL = API_REPORT + '/arrival'

export const API_REQUEST = '/request'
export const API_REQUEST_CALLBACK = API_REQUEST + '/callback'

export const API_FILES = '/files'

export const API_HEADER_BANNER = '/header-banner'

export const API_DADATA_INN =
  'https://suggestions.dadata.ru/suggestions/api/4_1/rs/findById/party'
export const API_DADATA_BIK =
  'https://suggestions.dadata.ru/suggestions/api/4_1/rs/findById/bank'
export const API_DADATA_SUGGEST_ADDRESS =
  'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address'
